module.exports = __webpack_public_path__ + "img/drive.4c728728.svg";